export const iconFontAwesomeScienceFlask = (
	<i className="fa-solid fa-flask"></i>
);
